import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import '../../styles/employee/personal-info.css';
import TopNavbar from '../top-navbar/TopNav';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getS3key, savePersonal } from '../../services/employee/api';

const PersonalInfo = ({ candidateId,personalInfoResponse, onBack }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem('bgc_token');
    const[error,setError] = useState('');
    const [personalImage, setPersonalImage] = useState(null);
    const [formData, setFormData] = useState({
        candidateId: candidateId,
        firstName: '',
        lastName: '',
        email: '',
        dob: '',
        fatherName: '',
        aadharNumber: '',
        mobileNumber: '',
        candidateImage: '',
        remarks: '',
        verificationStatus: false,
    });
    const [formErrors, setFormErrors] = useState({
        remarks: '',
        verificationStatus: '',
    });
    useEffect(() => {
        if (personalInfoResponse) {
            setFormData({
                candidateId: candidateId || '',
                firstName: personalInfoResponse.firstName || '',
                lastName: personalInfoResponse.lastName || '',
                email: personalInfoResponse.email || '',
                dob: personalInfoResponse.dateOfBirth || '',
                fatherName: personalInfoResponse.fatherName || '',
                aadharNumber: personalInfoResponse.aadhaarCardNumber || '',
                mobileNumber: personalInfoResponse.mobileNumber || '',
                candidateImage: personalInfoResponse.personalImageFileName || '',
                remarks: '',
                
            });
        }
    }, [personalInfoResponse]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData(prev => ({ ...prev, [name]: newValue }));
        setFormErrors(prev => ({
        ...prev,
        [name]: '',
    }));
    };

  useEffect(() => {
  if (!formData.candidateImage) return;

  const loadImage = async () => {
    try {
      let fileKey = formData.candidateImage;

      // remove full URL if present
      if (fileKey.includes(".com/")) {
        fileKey = fileKey.split(".com/")[1];
      }

      fileKey = decodeURIComponent(fileKey);

      const response = await getS3key(fileKey);

      const blobUrl = URL.createObjectURL(response.data);

      setPersonalImage({
        fileName: fileKey.split("/").pop(),
        url: blobUrl
      });

    } catch (error) {
      console.error("Error loading candidate image:", error);
    }
  };

  loadImage();

}, [formData.candidateImage]);


const validateForm = () => {
    let isValid = true;
    const errors = { remarks: '', verificationStatus: '' };
 
    if (!formData.remarks.trim()) {
        errors.remarks = 'Remarks are required.';
        isValid = false;
    }
 
    if (!formData.verificationStatus) {
        errors.verificationStatus = 'Verification status must be checked.';
        isValid = false;
    }
 
    setFormErrors(errors);
    return isValid;
};
 
    const handleSubmit = async (e) => {
   e.preventDefault();

        setError(null);
            if (!validateForm()) {
        return; // Stop submit if validation fails
    }
            try {
                const response = await savePersonal(formData);
                const result = response.data;
                toast.success("Personal Check data saved successfully", {
                    autoClose: 3000,
                });
                onBack();
                } catch (err) {
                    const message =
                    err.response?.data?.message ||
                    "Failed to verify personal background.";
                    setError(message);
                } finally {
                
                }
    };

    const handleCancel = () => {
        onBack();
    };

    PersonalInfo.propTypes = {
        candidateId: PropTypes.object,
        personalInfoResponse: PropTypes.object.isRequired,
        onBack: PropTypes.func.isRequired,
    };

    return (
        <div className="dashboard-app-container">
            <Sidebar />
            <div className="dashboard-right-panel">
                <TopNavbar />

                <div className="personal-info-header">
                        <h2>Personal Check</h2>
                    </div>

                <div className="personal-info-container">
                    
                    <div className="personal-details-card">
                        <h3>Personal Details</h3>
                        <form onSubmit={handleSubmit} className="personal-details-form">
                            <div className="form-row profile-pic-row">
                                <div className="profile-image-container">
                                    {personalImage?.url ? (
                                        <img
                                        src={personalImage.url}
                                        alt="Candidate"
                                        className="candidate-profile-image"
                                        />
                                    ) : (
                                        <p className="candidate-profile-text">
                                        <br />
                                        </p>
                                    )}
                                    </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="firstName">First Name</label>
                                    <input type="text" id="firstName" value={formData.firstName} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="lastName">Last Name</label>
                                    <input type="text" id="lastName" value={formData.lastName} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" value={formData.email} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="dob">Date of Birth</label>
                                    <input type="text" id="dob" value={formData.dob} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="fatherName">Father's Name</label>
                                    <input type="text" id="fatherName" value={formData.fatherName} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="aadharNumber">Aadhar Number</label>
                                    <input type="text" id="aadharNumber" value={formData.aadharNumber} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="mobileNumber">Mobile Number</label>
                                    <input type="text" id="mobileNumber" value={formData.mobileNumber} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row remarks-row">
                                <div className="form-group full-width">
                                    <label htmlFor="remarks">Remarks</label>
                                    <textarea
                                        id="remarks"
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                        className="form-textarea"
                                        placeholder="Type here..."
                                    ></textarea>
                                    {formErrors.remarks && <p className="error-text">{formErrors.remarks}</p>}
                                </div>
                            </div>

                            <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="verificationStatus"
                                            checked={formData.verificationStatus}
                                            onChange={handleChange}
                                        />{" "}
                                        Verification Status
                                    </label>
                                     {formErrors.verificationStatus && (
        <p className="error-text">{formErrors.verificationStatus}</p>
    )}
                                </div>

                            <div className="form-actions">
                                <button type="button" onClick={handleCancel} className="cancel-button">Cancel</button>
                                <button type="submit" className="submit-button">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalInfo;
